import { gsap } from 'gsap';

window.addEventListener('load', () => {
    const dot = document.querySelector('section.live-pricing h2.section_title');
    if (!dot) {
        return;
    }

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (prefersReducedMotion) {
        return;
    }

    gsap.to(dot, {
        '--pulse-scale': 1.12,
        '--pulse-glow': 2,
        duration: 1.1,
        ease: 'sine.inOut',
        repeat: -1,
        yoyo: true,
    });
});
